declare global {
  interface Window {
    ReactNativeWebView?: { postMessage: (message: string) => void };
  }
}

const pending = new Map<string, { resolve: (value: any) => void; reject: (error: Error) => void; timer?: ReturnType<typeof setTimeout> }>();
let listening = false;
let sequence = 0;
export const BRIDGE_CHANNEL = 'fanbird-broadcast';

// Tokens and stream credentials remain native; these are explicit, scoped capabilities.
export function nativeRequest<T>(type: 'qr-current' | 'qr-resolve' | 'qr-expose' | 'qr-capture' | 'list' | 'open' | 'cancel' | 'logout' | 'ready' | 'login' | 'start' | 'end' | 'back' | 'select-device' | 'permissions' | 'switch-camera' | 'toggle-camera' | 'toggle-mic' | 'toggle-preview-mirror' | 'focus' | 'chat-ticket' | 'product' | 'studio-data' | 'product-exposure' | 'live-notice' | 'seller-notice' | 'notification-preview' | 'notification-send', payload: Record<string, unknown> = {}): Promise<T> {
  if (!window.ReactNativeWebView) return Promise.reject(new Error('팬버드 송출 앱에서 열어주세요.'));
  if (!listening) {
    window.addEventListener('message', event => {
      try {
        const reply = JSON.parse(event.data);
        if (reply.channel !== BRIDGE_CHANNEL || reply.version !== 1) return;
        const request = pending.get(reply.id);
        if (!request) return;
        clearTimeout(request.timer);
        pending.delete(reply.id);
        if (reply.error) request.reject(new Error(reply.error));
        else request.resolve(reply.result);
      } catch { /* Ignore unrelated browser messages. */ }
    });
    listening = true;
  }
  return new Promise((resolve, reject) => {
    const id = `${Date.now()}-${++sequence}`;
    // A reservation cancellation waits for the user in the native confirmation dialog.
    // Its HTTP request has a separate timeout after the user confirms.
    const timer = ['cancel', 'start', 'permissions'].includes(type) ? undefined : setTimeout(() => {
      pending.delete(id);
      reject(new Error('응답이 지연되고 있습니다. 다시 시도해주세요.'));
    }, type === 'notification-send' ? 35000 : 20000);
    pending.set(id, { resolve, reject, timer });
    window.ReactNativeWebView!.postMessage(JSON.stringify({ ...payload, channel: BRIDGE_CHANNEL, version: 1, id, type }));
  });
}
